module.exports = __webpack_public_path__ + "static/media/Logo_vivo.c3f48c21.png";